import type { SiteConfig } from '../../types'
import { content } from './content'
import { background } from './background'

/*
 * Assembles and exports the organic-seeds SiteConfig. `id`, `domain` and
 * `locales` are structural and known; `content`, `background` and `features`
 * are still placeholders (real values arrive in Phases 1/2/4).
 */
const site: SiteConfig = {
  id: 'organic-seeds',
  domain: 'organic-seeds.at',
  locales: ['en', 'de'],
  defaultLocale: 'de',
  content,
  background,
  features: {
    hiddenPriceUntilHover: false,
    productRatings: false,
    wishlist: false,
    chat: false,
    googleMerchantBadge: false,
    affiliate: false,
    newsletter: false,
    ageGate: false,
  },
  // GA4: new property 'organic-seeds.at' created 2026-09-26 (the old WP
  // property G-M06Z5BVLYK belongs to an unknown Google login).
  // Search Console: domain property verified by DNS TXT at easyname; the meta
  // token below is the OLD site's token, kept so that owner stays verified.
  // No Google Ads / Merchant Center account for organic-seeds yet.
  analytics: {
    ga4Id: 'G-8EWG1SCK1V',
    googleAdsId: null,
    googleAdsPurchaseSendTo: null,
    googleSiteVerification: 'VkuNZKP_8BV5rA63adw19hpnJ-2tRm2Q9zyXl_TJNsg',
    merchantId: null,
  },
}

export default site
